import { render, staticRenderFns } from "./ChatMessagesModal.vue?vue&type=template&id=6be30314&scoped=true"
import script from "./ChatMessagesModal.vue?vue&type=script&lang=js"
export * from "./ChatMessagesModal.vue?vue&type=script&lang=js"
import style0 from "./ChatMessagesModal.vue?vue&type=style&index=0&id=6be30314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be30314",
  null
  
)

export default component.exports